export default "__VITE_ASSET__CFOMiqwo__"